$(document).ready(function(){

  if($(".images-product li").length > 3){
    $(".container-list-product").attr("style", "overflow-x: scroll;");
    $(".images-product").attr("style", "width: 900px;");
  }

  $(document).scroll(function() {
    if($(".pop-up-container-main").is(":visible")){
      $("html").addClass("overflow-hidden");
    }else{
      $("html").removeClass("overflow-hidden");
    }
  })

  $("#productoComplementario1").click(function(e){
    e.stopPropagation();
    $(".pop-up-container-main").attr("style", "display: flex");
  })

  if($(window).width() > 1024){
      $('.image-zoom')
        .wrap('<span style="display:inline-block"></span>')
        .css('display', 'block')
        .parent()
        .zoom({
          url: $('.image-zoom').attr('data-zoom'),
          callback: function(e){
            console.log(e)
          }
      });  
  }

  $(".image-container svg").click(function(){
    
    $("#volverAlDetalle").attr("style", "display:block; width: 100%; ");
    $(".col-pop-up-content").eq(1).attr("style", "display: none;");
    if($(window).width() <= 1024){
      $(".col-pop-up-content").eq(0).attr("style", "width: 100%;");
      $(".image-container .image-zoom").attr("style", "width: 100%;");
      //$(this).attr("style", "display:none;");
      //$(".image-details-mobile").attr("style", "display: flex;");
    }else{
      $(".col-pop-up-content").eq(0).attr("style", "width: 100%; flex-direction: row-reverse; flex-wrap: wrap; justify-content: flex-end;");
      $(".container-list-product").attr("style", "width: 100px; justify-content: flex-start; overflow-y: scroll;");
      $(".images-product").attr("style","width: 70px; height:400px; flex-direction: column;");
      $(".images-product li").attr("style", "width: 70px; height: 70px; margin: 10px; 0px;");
      $(".images-product li img").attr("style", "width: 70px; height: 70px;")
      $(".image-container").attr("style","width: 85%;");
      $(".image-container span").attr("style","display: flex; position: relative; overflow: hidden;justify-content: center;");
      $(".image-container .image-zoom").attr("style", "margin: 0 auto; max-width: 80%;");
    }
  });

  $("#volverAlDetalle").click(function(){
    $(this).attr("style", "display:none;");
    $(".col-pop-up-content").eq(1).attr("style", "display: flex;");
    if($(window).width() <= 1024){
      $(".image-zoom").attr("style", "transform: scale(1); transform-origin: 0% 0% 0px;")
      $(".image-container svg").attr("style", "display: block;");
      $(".col-pop-up-content").eq(0).attr("style", "width: 100%;");
      //$(".image-details-mobile").attr("style", "display: none;");  
    }else{
      $(".col-pop-up-content").eq(0).attr("style", "width: 50%;");
      if($(".images-product li").length > 3){
        $(".container-list-product").attr("style", "overflow-x: scroll;");
        $(".images-product").attr("style","width: 900px;");
      }else{
        $(".container-list-product").removeAttr("style");
        $(".images-product").removeAttr("style");
      }
      
      $(".images-product li").removeAttr("style");
      $(".images-product li img").removeAttr("style");
      $(".image-container").removeAttr("style");
      $(".image-container .image-zoom").removeAttr("style");
    }
    
  });

  $(".item-image-product").click(function(){
    $(".image-zoom").attr("src", $(this).attr("data-img-300"));
    $(".image-zoom").attr("data-zoom", $(this).attr("data-img-1024"));
    $(".image-container .zoomImg").attr("src", $(this).attr("data-img-1024"));
    $(".image-container .zoomImg").attr("data-zoom", $(this).attr("data-img-1024"));
  })
  
  
  
  /*document.querySelector(".image-details-mobile .zoom-plus").addEventListener('click', (e) => {
    if($(".image-details-mobile .zoom-plus").attr("data-count") != undefined){
      $(".image-details-mobile .zoom-plus").attr("data-count", (parseInt($(".image-details-mobile .zoom-plus").attr("data-count")) + 1));  
    } 
    
     $('.image-zoom').attr("src", $('.image-zoom').attr("data-zoom"));
     let infoContainer = document.querySelector(".image-zoom");
    console.log(infoContainer.style.transform);
     infoContainer.style.transform = "scale("+(1*parseInt($(".image-details-mobile .zoom-plus").attr("data-count")))+")";
     infoContainer.style.transformOrigin = '0% 0%';
  })

   document.querySelector(".image-details-mobile .zoom-minus").addEventListener('click', (e) => {
    if($(".image-details-mobile .zoom-plus").attr("data-count") != undefined){
      $(".image-details-mobile .zoom-plus").attr("data-count", (parseInt($(".image-details-mobile .zoom-plus").attr("data-count")) - 1));  
    } 
    
     $('.image-zoom').attr("src", $('.image-zoom').attr("data-zoom"));
     let infoContainer = document.querySelector(".image-zoom");
     if(parseInt($(".image-details-mobile .zoom-plus").attr("data-count")) > 0){
       infoContainer.style.transform = "scale("+(1*parseInt($(".image-details-mobile .zoom-plus").attr("data-count")))+")";
       infoContainer.style.transformOrigin = '0% 0%';
     }
  })*/
  
  
  $(".pop-up-header button").click(function(e){
    e.stopPropagation();
    $(".pop-up-container-main").attr("style", "display: none");
    $("html").removeClass("overflow-hidden");
  })

  $(".container-pop-up").click(function(e){
    e.stopPropagation();
  })

  $("#productoComplementario2").click(function(e){
    e.stopPropagation();
    $(".pop-up-container-main").attr("style", "display: flex");
  })

  $("html").click(function(e){
    $(".pop-up-container-main").attr("style", "display: none");
    $("html").removeClass("overflow-hidden");
  })
})